
import Vue from 'vue'
import Component from 'vue-class-component'

import TempAccount from '@/models/tempAccount'
import TempAccountService from '@/services/TempAccountService'

import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'

import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

const Props = Vue.extend({
  props: {
    onClose: Function,
  },
})

@Component({
  components: {
    ProgressLinear,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class TempAccountDelete extends Props {
  private dialog: boolean = false
  private isPending: boolean = false

  private tempAccounts: TempAccount[] = []
  private tempAccount: TempAccount = {} as TempAccount

  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  public show(accounts: TempAccount[], account: TempAccount) {
    this.tempAccounts = accounts
    this.tempAccount = account
    this.dialog = true
  }

  private hide() {
    this.onClose()
    this.dialog = false
  }

  private async _delete() {
    this.isPending = true
    try {
      await TempAccountService.delete(this.tempAccount)

      const index = this.tempAccounts.findIndex(
        (ta) => ta.ad_personne_id === this.tempAccount.ad_personne_id,
      )
      this.tempAccounts.splice(index, 1)

      this.$notificationService.success(
        this.$t('TEMPACCOUNT.DeleteTempAccountSuccess').toString(),
      )
      this.hide()
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
    this.isPending = false
  }
}
